import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {IBitrixUserModel} from '../../../../../../../../types/apps/crm/biitrix24/BitrixUserModel'
type Props = {
  column: ColumnInstance<IBitrixUserModel>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>
        <>{column.render('Header')}</>
      </th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
